// src/components/Loader.jsx
// 3.40.1: one loading look for the whole portal, the same as the sign-in
// loading screen: the logo inside a turning teal-and-green ring, with a short
// line under it. Used wherever a page, list or window is loading (Outbox,
// Inbox, Logs, Usage, Users, Console…), not for faxes being sent.
//   size: 'sm' (cards, pop-ups), 'md' (lists and pages), 'lg' (whole screen)
import { LOGO_DOTS_URL } from '../utils/brand';

const SIZES = { sm: [36, 20, 13], md: [58, 32, 14], lg: [96, 54, 15] };   // ring, logo, text

export default function Loader({ label = 'Loading…', size = 'md', style }) {
  const [ring, logo, text] = SIZES[size] || SIZES.md;
  const inset = Math.round(ring * 0.11);
  return (
    <div role="status" aria-live="polite" style={{ ...S.wrap, padding: size === 'sm' ? '14px 8px' : size === 'lg' ? 0 : '36px 12px', ...style }}>
      <style>{CSS}</style>
      <div style={{ position: 'relative', width: ring, height: ring }} aria-hidden="true">
        <div className="cp-loader-ring" style={{ ...S.ring, borderWidth: size === 'sm' ? 2.5 : 3 }} />
        <div className="cp-loader-core" style={{ ...S.core, inset, boxShadow: size === 'sm' ? '0 3px 10px rgb(var(--c-004d40-rgb) / 0.12)' : '0 10px 30px rgb(var(--c-004d40-rgb) / 0.15)' }}>
          <img src={LOGO_DOTS_URL} alt="" style={{ height: logo * 0.72 }} />   {/* 3.51.3: the logo's dots */}
        </div>
      </div>
      {label && <div style={{ ...S.label, fontSize: text }}>{label}</div>}
    </div>
  );
}

const S = {
  wrap: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, color: 'var(--t-00695c)', textAlign: 'center' },
  ring: { position: 'absolute', inset: 0, borderRadius: '50%', borderStyle: 'solid', borderColor: 'rgb(var(--c-00897b-rgb) / 0.12)', borderTopColor: 'var(--c-00897b)', borderRightColor: 'var(--b-43a047)' },
  core: { position: 'absolute', borderRadius: '50%', background: 'rgb(var(--c-ffffff-rgb) / 0.92)', display: 'grid', placeItems: 'center' },
  label: { fontWeight: 600, letterSpacing: '0.2px' },
};

const CSS = `
.cp-loader-ring { animation: spin .9s linear infinite; }
.cp-loader-core { animation: cpLoaderBreathe 1.8s ease-in-out infinite; }
@keyframes cpLoaderBreathe { 0%, 100% { transform: scale(1); } 50% { transform: scale(.94); } }
@keyframes spin { to { transform: rotate(360deg); } }
`;
